const initialState = {
  loading: "IDLE",
  allPlaylists: [],
};

function PlaylistReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_PLAYLIST_DATA":
      return { ...state, loading: "IN_PROGRESS" };

    case "FAIL_PLAYLIST_DATA":
      return { ...state, loading: "ERROR" };

    case "RECEIVE_PLAYLIST_DATA":
      return { ...state, loading: "COMPLETED", allPlaylists: action.payload };

    default:
      return state;
  }
}

export default PlaylistReducer;
